export default __webpack_public_path__ + "static/media/RobotoMono-Thin.4002d951.woff2";